import { faCrown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import '../styles/componentsStyles/TopLeaders.css';
import { getChallengeTypeUnit, getFormattedValue, getInitial } from '../../shared/util/challenges';
import { checkImage } from '../../shared/util/helperfunctions';

function SingleLeader({ leader, index, leadersNumber, challengeType }) {
  const [imageExists, setImageExists] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (leader?.image) {
      checkImage(leader?.image).then(setImageExists);
    }
  }, [leader?.image]);

  return (
    <div
      key={index}
      className={`leader leader-${index}`}
      role="group"
      aria-labelledby={` leader-progress-${index} leader-progress-unit-${index}`}
    >
      {index !== 0 && (
        <div className="leader-number" aria-hidden="true">
          {index + 1}
        </div>
      )}
      {index === 0 && <FontAwesomeIcon style={{ color: '#62BF92' }} icon={faCrown} />}
      <div className={`leader-avatar-outer leader-avatar-outer-${index}`}>
        <div
          className={`leader-avatar leader-avatar-${index} fs-exclude`}
          style={leader?.image && imageExists ? { backgroundImage: `url(${leader?.image})` } : {}}
        >
          <div
            aria-hidden="true"
            className="leader-initial"
            style={
              leader?.image && imageExists
                ? {
                    display: 'none',
                  }
                : {}
            }
          >
            {getInitial(leader?.name || '')}
          </div>
        </div>
      </div>
      <div
        className={`leader-progress leader-progress-${index} ${
          leadersNumber === 0 ? 'inactive' : 'active'
        }`}
        id={`leader-progress-${index}`}
        aria-hidden="true"
      >
        <span className="visuallyHidden">
          {index + 1} {t('CH046')}
        </span>
        {leader?.score ? getFormattedValue(leader?.score, challengeType) : 0}
      </div>
      <div
        className={`leader-progress-unit ${
          leadersNumber === 0 ? 'inactive' : 'active'
        } ${index === 0 ? 'first' : 'other'}`}
        id={`leader-progress-unit-${index}`}
        aria-hidden="true"
      >
        {getChallengeTypeUnit(challengeType, leader?.score)}
      </div>
    </div>
  );
}

export default SingleLeader;
